import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { LangProvider } from "@/i18n";
import Gateway from "@/pages/Gateway";
import PeopleWorld from "@/pages/PeopleWorld";
import PeopleCase from "@/pages/PeopleCase";
import AwsHub from "@/pages/AwsHub";
import AwsServiceDetail from "@/pages/AwsServiceDetail";
import MartechWorld from "@/pages/MartechWorld";
import GrowthServiceDetail from "@/pages/GrowthServiceDetail";
import ContactPage from "@/pages/ContactPage";
import HomeB from "@/pages/HomeB";
import HomeC from "@/pages/HomeC";
import HomeD from "@/pages/HomeD";
import HomeE from "@/pages/HomeE";
import Nosotros from "@/pages/Nosotros";
import BlogList from "@/pages/BlogList";
import BlogPost from "@/pages/BlogPost";
import CookieConsent from "@/components/CookieConsent";
import CookiePolicy from "@/pages/CookiePolicy";
import LegalNotice from "@/pages/LegalNotice";
import PrivacyPolicy from "@/pages/PrivacyPolicy";

const ScrollManager = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let frame;
    const raf = (time) => {
      lenis.raf(time);
      frame = requestAnimationFrame(raf);
    };
    frame = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(frame);
      lenis.destroy();
    };
  }, []);

  return (
    <LangProvider>
      <div className="App grain">
        <BrowserRouter>
          <ScrollManager />
          <Routes>
            <Route path="/" element={<HomeC />} />
            <Route path="/home-a" element={<Gateway />} />
            <Route path="/people-hr" element={<PeopleWorld />} />
            <Route path="/people-hr/caso-de-exito" element={<PeopleCase />} />
            <Route path="/aws" element={<AwsHub />} />
            <Route path="/aws/services/:slug" element={<AwsServiceDetail />} />
            <Route path="/martech" element={<MartechWorld />} />
            <Route path="/martech/services/:slug" element={<GrowthServiceDetail />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/home-b" element={<HomeB />} />
            <Route path="/home-c" element={<HomeC />} />
            <Route path="/home-d" element={<HomeD />} />
            <Route path="/home-e" element={<HomeE />} />
            <Route path="/nosotros" element={<Nosotros />} />
            <Route path="/blog" element={<BlogList />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/cookies/policy" element={<CookiePolicy />} />
            <Route path="/legal/notice" element={<LegalNotice />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="*" element={<HomeC />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="bottom-right" richColors />
        <CookieConsent />
      </div>
    </LangProvider>
  );
}

export default App;
